import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ViewWorkshopJobStoreService } from '../../view-workshop-job-store.service';
import { DialogRef } from '@angular/cdk/dialog';
import { CompletedEvent } from '../../../../models/workshop-job-event';
import { WORKSHOP } from '../../../../../testIds';
import { filter, takeUntil } from 'rxjs';
import { MatButton } from '@angular/material/button';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { AddCurrencyPrefixDirective } from '../../../../shared/directives/add-currency-prefix.directive';
import { MatInput } from '@angular/material/input';
import { TestIdDirective } from '../../../../shared/directives/test-id.directive';
import { MatFormField, MatLabel, MatPrefix } from '@angular/material/form-field';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';

@Component({
    selector: 'completed-dialog',
    templateUrl: './completed-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatDialogTitle, ReactiveFormsModule, MatDialogContent, MatFormField, TestIdDirective, MatLabel, MatInput, MatPrefix, AddCurrencyPrefixDirective, CdkTextareaAutosize, MatDialogActions, MatButton, MatDialogClose]
})
export class CompletedDialogComponent {
  testIds = WORKSHOP;
  form = new FormGroup({
    notes: new FormControl<string>(null),
    labour_hours: new FormControl<number>(null, Validators.required),
    labour_cost: new FormControl<number>(null, Validators.required)
  });

  constructor(
    private store: ViewWorkshopJobStoreService,
    private dialog: DialogRef<CompletedDialogComponent>
  ) {
    this.populateDefaultFromTemplate();
  }

  private populateDefaultFromTemplate() {
    this.store.template$
      .pipe(takeUntil(this.dialog.closed), filter(Boolean))
      .subscribe(({ labour_cost, labour_hours, parts }) => {
        if (labour_cost && this.form.value.labour_cost === null) {
          this.form.patchValue({ labour_cost: labour_cost / 100 });
        }
        if (this.form.value.labour_hours === null) {
          this.form.patchValue({ labour_hours: labour_hours });
        }
      });
  }
  saveWaitingForParts() {
    const { notes, labour_hours, labour_cost } = this.form.value;
    const event: Partial<CompletedEvent> = {
      type: 'completed',
      details: {
        notes,
        labour_hours,
        labour_cost: labour_cost * 100
      }
    };
    this.store.addEvent({ event, onSuccess: () => this.dialog.close() });
  }
}
